var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "network-container",
    attrs: {
      "fill-height": "",
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('v-app-bar', {
    attrs: {
      "app": "",
      "clipped-right": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ws-detail-title"
  }, [_c('v-icon', {
    staticClass: "ml-4 mr-5",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v(" mdi-text-box-multiple ")]), _c('span', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workspaceDetail',
        params: {
          workspace: _vm.workspace
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.workspace))]), _c('v-icon', {
    staticClass: "mx-4",
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("mdi-chevron-right")]), _c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-chart-timeline-variant")]), _vm._v(" " + _vm._s(_vm.network) + " ")], 1)], 1), _c('v-spacer'), _c('workspace-option-menu', {
    attrs: {
      "workspace": _vm.workspace
    }
  })], 1), _c('v-main', {
    staticClass: "fill-height"
  }, [_c('v-container', {
    attrs: {
      "align-stretch": "",
      "d-flex": "",
      "fill-height": "",
      "flex-column": "",
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('div', {
    class: _vm.networkVisClasses
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-title', [_vm._v(" Nodes: " + _vm._s(_vm.totalNodes) + " ")])], 1), _c('v-list-item', [_c('v-list-item-title', [_vm._v(" Edges: " + _vm._s(_vm.totalEdges) + " ")])], 1)], 1), _c('v-navigation-drawer', {
    attrs: {
      "absolute": "",
      "right": "",
      "permanent": ""
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v(" More ways to visualize ")]), _c('v-divider'), _c('div', {
    staticClass: "grey lighten-4 pa-3"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.visItems,
      "background-color": "white",
      "dense": "",
      "hide-details": "",
      "label": "Visualization",
      "menu-props": "auto",
      "outlined": ""
    },
    model: {
      value: _vm.selectedVis,
      callback: function ($$v) {
        _vm.selectedVis = $$v;
      },
      expression: "selectedVis"
    }
  })], 1), _c('v-divider'), _vm._l(_vm.apps.network_visualizations, function (app) {
    return _c('v-list-item', {
      key: app.name,
      staticClass: "pl-2",
      attrs: {
        "href": ((app.url) + "/?workspace=" + (_vm.workspace) + "&network=" + (_vm.network)),
        "target": "_blank"
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "mr-3"
    }, [_c('v-icon', {
      attrs: {
        "color": "blue lighten-3"
      }
    }, [_vm._v(" mdi-exit-to-app ")])], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(app.name) + " ")]), _c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": "blue lighten-3"
      }
    }, [_vm._v(" mdi-chevron-right ")])], 1)], 1);
  })], 2)], 1)], 1), _c('div', {
    class: _vm.nodeColsClasses
  }, [_c('div', {
    staticClass: "node-types flex-grow-1"
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%",
      "tile": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "blue darken-1",
      "dark": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(" Node Types ")])], 1), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list', {
    staticClass: "node-type-list pa-0",
    attrs: {
      "color": "transparent",
      "dense": ""
    }
  }, [_vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.nodeTypes, function (table) {
    return _c('v-list-item', {
      key: table.name,
      staticClass: "pl-2",
      attrs: {
        "to": ("/workspaces/" + (_vm.workspace) + "/table/" + table)
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1",
        "size": "18"
      }
    }, [_vm._v(" mdi-scatter-plot ")])], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(table) + " ")]), _c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(" mdi-chevron-right ")])], 1)], 1);
  })], 2)], 1)], 1)], 1), _c('div', {
    staticClass: "edge-types flex-grow-1"
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-5",
      "flat": "",
      "height": "100%",
      "tile": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "blue darken-2",
      "dark": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(" Edge Types ")])], 1), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list', {
    staticClass: "edge-type-list pa-0",
    attrs: {
      "color": "transparent",
      "dense": ""
    }
  }, [_vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.edgeTypes, function (table) {
    return _c('v-list-item', {
      key: table.name,
      staticClass: "pl-2",
      attrs: {
        "to": ("/workspaces/" + (_vm.workspace) + "/table/" + table)
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1",
        "size": "18"
      }
    }, [_vm._v(" mdi-merge ")])], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(table) + " ")]), _c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(" mdi-chevron-right ")])], 1)], 1);
  })], 2)], 1)], 1)], 1), _c('div', {
    staticClass: "nodes-list flex-grow-1"
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%",
      "tile": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "blue darken-1",
      "dark": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(" Nodes ")]), _c('v-spacer'), _c('div', {
    staticClass: "pagination"
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": !_vm.prev
    },
    on: {
      "click": function ($event) {
        return _vm.firstPage();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-previous")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": !_vm.prev
    },
    on: {
      "click": function ($event) {
        return _vm.turnPage(false);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": !_vm.next
    },
    on: {
      "click": function ($event) {
        return _vm.turnPage(true);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": !_vm.next
    },
    on: {
      "click": function ($event) {
        return _vm.lastPage();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-next")])], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list', {
    staticClass: "node-list pa-0",
    attrs: {
      "color": "transparent",
      "dense": ""
    }
  }, [_vm.loading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.nodes, function (node) {
    return _c('v-list-item', {
      key: node,
      attrs: {
        "to": ("/workspaces/" + (_vm.workspace) + "/network/" + (_vm.network) + "/node/" + node)
      }
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(node) + " ")])], 1);
  })], 2)], 1)], 1)], 1), _c('v-btn', {
    staticClass: "tray-action",
    attrs: {
      "color": "blue darken-2",
      "dark": "",
      "depressed": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "size": "18"
    }
  }, [_vm._v(" " + _vm._s(_vm.drawerIcon) + " ")])], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }